import React, { memo } from "react";

const Djradio = memo(() => {
  return <div>Djradio</div>;
});

export default Djradio;
